module.exports = __webpack_public_path__ + "static/img/f5.ce93f81.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/custom/f5.png
// module id = 3OI8
// module chunks = 0